"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LeadFollowUpRo = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.LeadFollowUpRo = typebox_1.Type.Object({
    first_name: typebox_1.Type.String(),
    dumpster_size: typebox_1.Type.String(),
    quote_total: typebox_1.Type.String(),
    material: typebox_1.Type.String(),
    csa_name: typebox_1.Type.String(),
    quote_url: typebox_1.Type.String(),
    custom_message: typebox_1.Type.String(),
    /**
     * as an empty string or in yyyy-mm-dd format
     */
    last_order_date: typebox_1.Type.String(),
    service_location: typebox_1.Type.String(),
    rental_period: typebox_1.Type.String(),
});
//# sourceMappingURL=lead-follow-up-ro.js.map